<div class="question-true-false">
  <p class="question-text">{{ question.questionText }}</p>

  <div class="options">
    <label class="option">
      <span class="option-text">True</span>
      <input
        type="radio"
        [name]="'tf-' + question.id"
        [checked]="selected === true"
        (change)="onSelect(true)"
      />
    </label>

    <label class="option">
      <span class="option-text">False</span>
      <input
        type="radio"
        [name]="'tf-' + question.id"
        [checked]="selected === false"
        (change)="onSelect(false)"
      />
    </label>
  </div>
</div>
